import React from "react"
import { withTranslation } from "gatsby-plugin-react-i18next"
import styled from "styled-components"
import colors from "../../styles/colors"
import fonts from "../../styles/fonts"

const Sticker = styled.div`
  z-index: 1;
  position: absolute;
  top: 13px;
  left: 13px;
  ${fonts.helveticaNeueLight};
  font-size: 10px;
  font-style: italic;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0px;
  text-align: center;
  background: ${colors.white};
  min-height: 23px;
  min-width: 104px;
  p {
    width: 100%;
    height: 100%;
    background: rgba(135, 161, 152, 0.5);
    color: ${colors.green};
    padding: 5px 5px 6px;
  }

  @media(max-width: 360px) {
    left: 4px;
    top: 4px;
  }
`

const OutOfStockSticker = ({children, t}) => {
  return (
    <Sticker>
      <p>{children ? children : t("pdp.sold_out")}</p>
    </Sticker>
  )
}

export default withTranslation()(OutOfStockSticker)
